// UI Configuration data

export interface FilterOption {
  label: string;
  value: string;
}

export interface LinkPart {
  type: "link";
  text: string;
  url: string;
}
export interface FAQ {
  q: string;
  a: string | (string | LinkPart)[];
}

// Aksara page filters
export const aksaraFilters: FilterOption[] = [
  { label: "All Characters", value: "all" },
  { label: "Learned", value: "mastered" },
  { label: "On Progress", value: "active" },
  { label: "Unlearned", value: "not-started" },
];

// Settings page FAQ data
export const settingsFAQ: FAQ[] = [
  {
    q: "Kursus bahasa apa saja yang tersedia saat ini?",
    a: "Saat ini tersedia kursus Bahasa Batak Toba. Kursus bahasa lain akan ditambahkan di masa mendatang.",
  },
  {
    q: "Bagaimana menambahkan kursus bahasa baru?",
    a: "Klik dropdown di bagian atas layar, lalu pilih 'Tambah Kursus Baru'. Untuk saat ini, hanya kursus Bahasa Batak Toba yang tersedia. Kursus bahasa lain akan ditambahkan di masa mendatang.",
  },
  {
    q: "Bagaimana cara mengganti avatar?",
    a: "Klik gambar avatar di bagian profil, pilih avatar yang diinginkan, lalu tekan tombol 'Simpan' untuk menyimpan perubahan avatar Anda.",
  },
  {
    q: "Bagaimana cara mengaktifkan mode gelap?",
    a: "Gunakan toggle di bagian Preferensi untuk mengaktifkan atau menonaktifkan mode gelap.",
  },
  {
    q: "Bagaimana cara membeli nyawa?",
    a: "• Untuk membeli nyawa, tekan ikon hati di bagian atas halaman, lalu ikuti instruksi pembelian yang tersedia.\n\n• Kamu bisa membeli 1 nyawa dengan harga 50 uang atau menunggu selama 1 menit untuk mengisi 1 nyawa.\n\n• Kamu tidak bisa memulai pelajaran jika nyawamu habis, jadi pastikan nyawa kamu selalu cukup.",
  },
  {
    q: "Bagaimana cara mendapatkan uang?",
    a: "Uang dapat diperoleh dengan menyelesaikan pelajaran, menjawab pertanyaan dengan benar, dan meraih pencapaian di aplikasi.",
  },
  {
    q: "Apakah progress saya akan hilang jika logout?",
    a: "Progress Anda tersimpan di perangkat. Pastikan untuk mengekspor progress sebelum logout jika ingin memindahkan ke perangkat lain.",
  },
  {
    q: "Bagaimana cara mengekspor dan mengimpor progress?",
    a: "• Untuk mengekspor progress, tekan tombol 'Export Progress' di bagian profil. File progress Anda akan diunduh dalam format JSON.\n\n• Untuk mengimpor progress, tekan tombol 'Import Progress' di bagian profil, lalu pilih file JSON progress yang sudah diekspor sebelumnya. Progress Anda saat ini akan hilang dan digantikan oleh progress dari file yang diimpor.",
  },
  {
    q: "Siapa yang bisa saya hubungi untuk bantuan?",
    a: [
      "Silahkan hubungi tim kami di: \n• Instagram: ",
      {
        type: "link",
        text: "@galaxy.developer",
        url: "https://www.instagram.com/galaxy.developer/",
      },
      "\n• LinkedIn: ",
      {
        type: "link",
        text: "Galaxy Developer",
        url: "https://www.linkedin.com/company/galaxydeveloper",
      },
    ],
  },
];

// Styling configurations for different status states
export const statusStyles = {
  mastered: {
    box: {
      light:
        "border-green-500 text-green-500 bg-green-100 hover:bg-green-200 hover:shadow-green-300/40",
      dark: "border-green-400 text-green-300 bg-green-950 hover:bg-green-900 hover:shadow-green-900/40",
    },
    bar: {
      light: "bg-green-400",
      dark: "bg-green-600",
    },
  },
  active: {
    box: {
      light:
        "border-yellow-400 text-yellow-700 bg-yellow-50 hover:bg-yellow-100 hover:shadow-yellow-300/40",
      dark: "border-yellow-300 text-yellow-200 bg-yellow-900 hover:bg-yellow-800 hover:shadow-yellow-900/40",
    },
    bar: {
      light: "bg-yellow-400",
      dark: "bg-yellow-500",
    },
  },
  "not-started": {
    box: {
      light: "border-gray-400 text-gray-400 bg-gray-100",
      dark: "border-gray-600 text-gray-500 bg-gray-800",
    },
    bar: {
      light: "bg-gray-500",
      dark: "bg-gray-700",
    },
  },
};

// XP configuration for different question types
export const xpConfiguration = {
  defaultXpByType: {
    "vocab-intro": 0,
    "word-translation": 0,
    "compose-sentences": 0,
    "matching-words": 0,
    "fill-in-the-blank": 0,
  },
  maxXpPerType: 10,
};

// Game configuration
export const gameConfig = {
  defaultHearts: 5,
  maxAccuracy: 100,
};
